import { lazy } from 'react';

import { ReactWebComponent } from '@app/utils/web-components';

const AppProviders = lazy(() => import('@app/components/AppProviders'));
const UploadFilesList = lazy(() => import('./UploadFilesList'));

class UploadFilesListComponent extends ReactWebComponent {
    static get observedAttributes() {
        return ['project-id', 'project-uuid'];
    }

    render() {
        const projectId = this.prop('project-id');
        const projectUuid = this.prop('project-uuid');

        return (
            <AppProviders>
                <UploadFilesList projectId={projectId} projectUuid={projectUuid} />
            </AppProviders>
        );
    }
}

customElements.define('upload-files-list', UploadFilesListComponent);
